export const ACT_TYPES = {
  BANK_TRANSFER_OUT: 'BANK_TRANSFER_OUT',
  BANK_TRANSFER_IN: 'BANK_TRANSFER_IN',
  MANUAL_MOVEMENT: 'MANUAL_MOVEMENT',
  CARD_PURCHASE: 'CARD_PURCHASE',
  EXTRACASH: 'EXTRACASH',
  EXTRACASH_TYPE: 'Extracash'
}
